/**
 * Job Analyzer translations
 * Job analysis page UI text
 */

import { LANGUAGES } from '../config';

export const jobAnalyzerTranslations = {
  [LANGUAGES.EN]: {
    title: 'Job Analyzer',
    uploadStep: 'Upload Job Posting',
    reviewStep: 'Review Analysis',
    uploadText: 'Upload job posting files or drag and drop them here',
    pasteText: 'Or paste job posting text directly',
    skillResults: 'Job Skills Analysis',
    skillsAnalysisResults: 'Job Skills Analysis Results',
    addSkill: 'Add Skill',
    addNewSkill: 'Add New Skill',
    editSkill: 'Edit Skill',
    skill: 'Skill',
    skillName: 'Skill Name',
    skillColumn: 'Skill',
    categoryColumn: 'Category',
    importanceColumn: 'Importance',
    contextColumn: 'Context',
    category: 'Category',
    checkingCompanyResearch: 'Checking for company research data...',
    categoryLoadError: 'Failed to load job categories from the backend.',
    mustCompleteCompanyResearch: 'You must complete company research before analyzing job postings. This ensures job skills are analyzed in the context of company culture and requirements.',
    goToCompanyResearch: 'Go to Company Research',
    categoryTechnical: 'Competences techniques',
    categorySoftSkills: 'Competences comportementales',
    categoryTools: 'Outils et plateformes',
    categoryMethodologies: 'Methodologies et pratiques de travail',
    categoryDomainKnowledge: 'Connaissance du domaine',
    categoryOther: 'Other',
    importance: 'Importance',
    importanceRequired: 'Required',
    importancePreferred: 'Preferred',
    importanceNiceToHave: 'Nice to Have',
    context: 'Context',
    technical: 'Competences techniques',
    softSkills: 'Competences comportementales',
    tools: 'Outils et plateformes',
    methodologies: 'Methodologies et pratiques de travail',
    domainKnowledge: 'Connaissance du domaine',
    other: 'Other',
    required: 'Required',
    preferred: 'Preferred',
    niceToHave: 'Nice to Have',
    contextEvidence: 'Context / Evidence',
    noSkills: 'No skills found. Add some using the button above.',
    savedSuccessfully: 'Job analysis saved successfully!',
    analysisFailed: 'Job analysis failed',
    processing: 'Processing job posting...',
    dragAndDrop: 'Drag and drop job posting here, or click to select file',
    matching: 'CV Match',
    regenerateMatching: 'Regenerate CV Matching',
    regeneratingMatching: 'Regenerating...'
  },
  [LANGUAGES.FR]: {
    title: 'Analyseur d\'offres d\'emploi',
    uploadStep: 'Telecharger l\'offre d\'emploi',
    reviewStep: 'Reviser l\'analyse',
    uploadText: 'Telechargez des fichiers d\'offre d\'emploi ou glissez-les ici',
    pasteText: 'Ou collez le texte de l\'offre d\'emploi directement',
    skillResults: 'Analyse des competences professionnelles',
    skillsAnalysisResults: 'Resultats d\'analyse des competences professionnelles',
    addSkill: 'Ajouter une competence',
    addNewSkill: 'Ajouter une nouvelle competence',
    editSkill: 'Modifier la competence',
    skill: 'Competence',
    skillName: 'Nom de la competence',
    skillColumn: 'Competence',
    categoryColumn: 'Categorie',
    importanceColumn: 'Importance',
    contextColumn: 'Contexte',
    category: 'Categorie',
    checkingCompanyResearch: 'Verification des donnees de recherche d\'entreprise...',
    categoryLoadError: 'Echec du chargement des categories d\'emploi depuis le backend.',
    mustCompleteCompanyResearch: 'Vous devez effectuer la recherche d\'entreprise avant d\'analyser les offres d\'emploi. Cela garantit que les competences sont analysees dans le contexte de la culture et des exigences de l\'entreprise.',
    goToCompanyResearch: 'Aller a la recherche d\'entreprise',
    categoryTechnical: 'Competences techniques',
    categorySoftSkills: 'Competences comportementales',
    categoryTools: 'Outils et plateformes',
    categoryMethodologies: 'Methodologies et pratiques de travail',
    categoryDomainKnowledge: 'Connaissance du domaine',
    categoryOther: 'Autre',
    importance: 'Importance',
    importanceRequired: 'Requis',
    importancePreferred: 'Prefere',
    importanceNiceToHave: 'Bon a avoir',
    context: 'Contexte',
    technical: 'Competences techniques',
    softSkills: 'Competences comportementales',
    tools: 'Outils et plateformes',
    methodologies: 'Methodologies et pratiques de travail',
    domainKnowledge: 'Connaissance du domaine',
    other: 'Autre',
    required: 'Requis',
    preferred: 'Prefere',
    niceToHave: 'Bon a avoir',
    contextEvidence: 'Contexte / Evidence',
    noSkills: 'Aucune competence trouvee. Ajoutez-en a l\'aide du bouton ci-dessus.',
    savedSuccessfully: 'Analyse de l\'emploi enregistree avec succes!',
    analysisFailed: 'L\'analyse de l\'emploi a echoue',
    processing: 'Traitement de l\'offre d\'emploi...',
    dragAndDrop: 'Glissez et deposez l\'offre d\'emploi ici, ou cliquez pour selectionner un fichier',
    matching: 'Concordance CV',
    regenerateMatching: 'Regenerer la concordance CV',
    regeneratingMatching: 'Regeneration en cours...'
  }
};
